type T = (id: string) => boolean;

const f: T = (id) => {
    return id ? /^[a-zA-Z0-9]{5,10}$/.test(id) : false;
};

export default f;
